import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Header, SpaceBetween, AppLayout } from '@amzn/awsui-components-react-v3';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
export const PageNotFound = () => {
    const { t } = useTranslation();
    const content = () => {
        return (_jsx(Box, { className: "error-center", children: _jsxs(SpaceBetween, { size: "m", children: [_jsxs(Box, { children: [_jsx("img", { src: "/public/error-page.svg", alt: "error" }), _jsxs(Header, { variant: "h1", children: [" ", t('page_not_found_text'), " "] }), _jsx("p", { children: t('page_not_found_description') }), _jsx("p", { children: _jsx(Link, { to: "/", children: t('go_to_homepage_text') }) })] }), _jsx("br", {})] }) }));
    };
    return _jsx(AppLayout, { content: content(), toolsHide: true, navigationHide: true });
};
